import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { Account } from '../models/Account';
import { AccountSearchCriteria } from '../models/searchCriteria/AccountSearchCriteria';

@Injectable({
  providedIn: 'root'
})
export class AccountService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: AccountSearchCriteria): Observable<PagedData<Account>> {
    return this.httpClient.post<PagedData<Account>>(environment.apiUrl + "accounts/filtered", searchCriteria);
  }

  get(accountId: string): Observable<Account> {
    return this.httpClient.get<Account>(environment.apiUrl + "accounts/" + accountId);
  }

  save(account: Account): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "accounts", account);
  }

  disable(accountId: string): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "accounts/" + accountId);
  }

  sync(): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "accounts/sync", {});
  }
}
